<template>
  <v-container class="page">
    <table>
      <tbody>
        <br><br>
        <div>
          <table style="border: 1px solid; text-align: left; font-size: 12px;">
            <tbody>
              <tr>
                <td style="width: 250px;"></td>
                <td></td>
              </tr>
              <tr>
                <th colspan="2" style="border: 1px solid; background-color: #ffffcc; text-align: center; font-size: 24px;">
                  ARKUSZ MIESIĘCZNY MATERIAŁÓW EDUKACYJNYCH
                </th>
              </tr>
              <tr>
                <td style="border: 1px solid; width: 100px;">
                  <p class="cell-in-first-table"><span><strong>Nazwisko i Imię:</strong></span></p>
                </td>
                <td style="border: 1px solid; background-color: #ffffcc;">
                  <p class="cell-in-first-table"><span><strong>{{ imie }} {{ nazwisko }}</strong></span></p>
                </td>
              </tr>
              <tr>
                <td style="border: 1px solid;">
                  <p class="cell-in-first-table"><span><strong>Okres:</strong></span></p>
                </td>
                <td style="border: 1px solid; background-color: #ffffcc;">
                  <p class="cell-in-first-table"><span><strong>{{ miesiac }}</strong></span></p>
                </td>
              </tr>
              <tr>
                <td colspan="2" style="border: 1px solid; background-color: #fff; text-align: center; font-size: 24px; height: 20px;"></td>
              </tr>
            </tbody>
          </table>

          <tr style="text-align: center;">
            <td style="border: 1px solid; background-color: #ffffcc; width: 100px;">
                <p class="cell-in-first-table">L.p. dzień miesiąca</p>
            </td>
            <td style="border: 1px solid; background-color: #ffffcc;">
                <p class="cell-in-first-table">Dzień tygodnia</p>
            </td>
            <td style="border: 1px solid; background-color: #ffffcc; width: 350px;">
                <p class="cell-in-first-table">Opis zadań twórczych / Nazwa Materialu Edukacyjnego (ME)/ Ewentualny urlop wypoczynkowy (UW)</p>
            </td>
            <td style="border: 1px solid; background-color: #ffffcc;">
                <p class="cell-in-first-table">Ilość przepracowanych <strong>godzin twórczych</strong></p>
            </td>
            <td style="border: 1px solid; background-color: #ffffcc;">
                <p class="cell-in-first-table">Ilość przepracowanych <strong>godzin na czynności pozostałe</strong></p>
            </td>
            <td style="border: 1px solid; background-color: #ffffcc;">
                <p class="cell-in-first-table">Łączna ilość przepracowanych godzin</p>
            </td>
          </tr>

          <tr 
            v-for="(date, index) in datyTab"
            v-bind:key="index"
            style="text-align: center;"
          >
            <td style="border: 1px solid;">
                <p class="cell-in-first-table">{{ date }}</p>
            </td>
            <td style="border: 1px solid;">
                <p class="cell-in-first-table">{{ dniTygodniaTab[index] }}</p>
            </td>
            <td style="border: 1px solid;">
                <p class="cell-in-first-table">{{ opisyZadanTworczychTab[index] }}</p>
            </td>
            <td style="border: 1px solid;">
                <p class="cell-in-first-table">{{ iloscGodzinTworczychTab[index] }}</p>
            </td>
            <td style="border: 1px solid;">
                <p class="cell-in-first-table">{{ iloscPozostalychGodzinTab[index] }}</p>
            </td>
            <td style="border: 1px solid;">
                <p class="cell-in-first-table">{{ iloscGodzinTab[index] }}</p>
            </td>
          </tr>

          <tr>
              <td colspan="3" style="border: 1px solid;">
                  <p class="cell-in-first-table"><strong>Łącznie godzin</strong></p>
              </td>
              <td style="text-align: center; border: 1px solid;" >
                  <p class="cell-in-first-table"><strong>{{ sumaTworczeFloor }}</strong></p>
              </td>
              <td style="text-align: center; border: 1px solid;">
                  <p class="cell-in-first-table"><strong>{{ sumaPozostaleFloor }}</strong></p>
              </td>
              <td style="text-align: center; border: 1px solid;">
                  <p class="cell-in-first-table"><strong>{{ sumaGodzin }}</strong></p>
              </td>
          </tr>

           <!-- Wykaz utworów -->
    <tr>
        <td style="height: 20px;"></td>
    </tr>
    <tr>
        <td colspan="3">
            <p style="border: 1px solid; padding-left: 10px;"><strong>Wykaz utworów pracowniczych stworzonych w miesiącu (mm-rr):</strong></p>
        </td>
        <td colspan="3">
            <p style="border: 1px solid; padding-left: 10px; background-color: #ffffcc;"><strong>{{ miesiac }}</strong></p>
        </td>
    </tr>
    <tr v-for="(utwor, index) in wykazyUtworowTab" :key="index">
        <td style="border: 1px solid; background-color: #ffffcc;">
            <p class="cell-in-first-table" style="text-align: center;"><strong>{{ index + 1 }}.</strong></p>
        </td>
        <td colspan="5" style="border: 1px solid;">
            <p class="cell-in-first-table">{{ utwor }}</p>
        </td>
    </tr>
    <tr>
        <td style="height: 20px;"></td>
    </tr>
    <tr style="background-color: #ffffcc;">
        <td colspan="5" style="border: 1px solid;">
            <p class="cell-in-first-table"><strong>Procentowy udział godzin twórczych w danym miesiącu</strong></p>
        </td>
        <td style="text-align: center; border: 1px solid;">
            <p class="cell-in-first-table"><strong>{{ procentowyUdzialGodzin }} %</strong></p>
        </td>
    </tr>
    <tr>
        <td style="height: 30px;"></td>
    </tr>
    <tr>
        <td></td>
        <td></td>
        <td colspan="2" style="background-color: #a4c2f4;">
            <p class="cell-in-first-table">Imię i nazwisko koordynatora zatwierdzającego Arkusz:</p>
        </td>
        <td>
            <p class="cell-in-first-table">{{ koordynator }}</p>
        </td>
    </tr>
    <tr>
        <td style="height: 20px;"></td>
    </tr>
    <tr>
        <td></td>
        <td></td>
        <td colspan="2" style="background-color: #a4c2f4;">
            <p class="cell-in-first-table">Osoba Zatwierdzajaca Dział Edukacja z datą zatwierdzenia Arkusza</p>
        </td>
        <td>
            <p class="cell-in-first-table">{{ osobaZatwierdzajaca }}</p>
        </td>
    </tr>
    <tr>
        <td style="height: 20px;"></td>
    </tr>
    <tr>
        <td></td>
        <td></td>
        <td colspan="2" style="background-color: #a4c2f4;">
            <p class="cell-in-first-table">Imię i nazwisko pracownika działu kadr i płac zatwierdzającego do rozliczenia</p>
        </td>
        <td>
            <p class="cell-in-first-table">{{ kadryPlace }}</p>
        </td>
    </tr>

  </div>
  </tbody></table>
  </v-container>

</template>

<script>
export default {
  name: 'ArkuszMaterialow',
  data() {
    return {
      imie: '',
      nazwisko: '',
      miesiac: '',
      sumaTworcze: '',
      sumaPozostale: '',
      sumaGodzin: '',
      procentowyUdzial: 0,
      koordynator: '',
      osobaZatwierdzajaca: '',
      kadryPlace: '',
      daty: '',
      dniTygodnia: '',
      opisyZadanTworczych: '',
      iloscGodzinTworczych: '',
      iloscPozostalychGodzin: '',
      iloscGodzin: '',
      wykazyUtworow: '',
      wykazyUtworow2: '',
      error: null
    }
  },
  computed: {
    datyTab() {
      return this.safeSplit(this.daty);
    },
    dniTygodniaTab() {
      return this.safeSplit(this.dniTygodnia);
    },
    opisyZadanTworczychTab() {
      return this.safeSplit(this.opisyZadanTworczych, false);
    },
    iloscGodzinTworczychTab() {
      return this.safeSplit(this.iloscGodzinTworczych, false);
    },
    iloscPozostalychGodzinTab() {
      return this.safeSplit(this.iloscPozostalychGodzin, false);
    },
    iloscGodzinTab() {
      return this.safeSplit(this.iloscGodzin, false);
    },
    wykazyUtworowTab() {
      return [
        ...this.safeSplit(this.wykazyUtworow),
        ...this.safeSplit(this.wykazyUtworow2)
      ].filter(item => item);
    },
    sumaTworczeFloor() {
      return this.parseNumber(this.sumaTworcze).toFixed(2);
    },
    sumaPozostaleFloor() {
      return this.parseNumber(this.sumaPozostale).toFixed(2);
    },
    procentowyUdzialGodzin() {
      const decimalSumaTworcze = this.parseNumber(this.sumaTworcze);
      const decimalSumaGodzin = this.parseNumber(this.sumaGodzin);
      const procenty = Math.round((decimalSumaTworcze / decimalSumaGodzin) * 100);
      return isNaN(procenty) ? 0 : procenty;
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      try {
        // Dane w hash URL (Too long URL)
        if (this.$route.hash && this.$route.hash.startsWith('#data=')) {
          const base64 = this.$route.hash.replace('#data=', '');
          const json = atob(decodeURIComponent(base64));
          const data = JSON.parse(json);
          Object.assign(this.$data, data);
          return;
        }

        // standard parametry URL
        Object.entries(this.$route.query).forEach(([key, value]) => {
          if (key in this.$data) {
            this[key] = decodeURIComponent(value);
          }
        });

      } catch (e) {
        console.error('Błąd ładowania danych:', e);
        this.error = 'Nie można załadować danych. Link może być uszkodzony.';
      }
    },
    safeSplit(str, filterEmpty = true) {
      if (!str) return [];
      const parts = String(str).split('|');
      return filterEmpty ? parts.filter(p => p.trim()) : parts;
    },
    parseNumber(value) {
      const num = parseFloat(String(value).replace(/,/g, '.'));
      return isNaN(num) ? 0 : num;
    }
  },
  mounted() {
    if (this.imie) {
      this.$nextTick(() => {
        setTimeout(() => {
          const currentURL = window.location.href;
          history.replaceState(null, null, '/');
          window.print();
          history.replaceState(null, null, currentURL);
        }, 500);
      });
    }
  }
}
</script>

<style scoped>
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 2px;
  padding-top: 0px;
}
table {
  border: 1px;
  border-collapse: collapse;
  table-layout: fixed;
  width: 900px;
}
th, td {
  border: 1px;
  border-collapse: collapse;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 10px;
  margin-right: 10px;
}
ul.dashed {
  list-style-type: "- ";
  margin: 0;
}
.underline {
  text-decoration: underline;
}
.pageNum {
  position: absolute;
  right: 0px;
  font-size: 14px;
}
#oswiadczenie {
  padding: 20px;
  color: red;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/ArkuszMaterialow.vue